import {CreationAttribute, FieldName} from '../../../typedefs';

export const attributeMapToAttributeRowInfo = (attribute?: CreationAttribute) => {
    if (attribute) {
        return {
            ...attribute,
            [FieldName.ATTRIBUTE_ID]: '',
            [FieldName.DESCRIPTION]: attribute?.description ?? null,
        };
    }
    return attribute;
};
